module.exports = __webpack_public_path__ + "static/media/17 Crossface.322d9ae1.jpg";